import CONFIG from '@/config/config.ts';
import { DomPurifyConfig } from '@/config/DomPurify.config.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { QuestionSegmentProps } from '@/views/process/components/quizInialized/questions/QuestionSegment.model.ts';
import QuestionWrapper from '@/views/process/components/quizInialized/questions/QuestionWrapper.tsx';
import DOMPurify from 'dompurify';
import parseHtml from 'html-react-parser';
import { FC, useState } from 'react';

const audioUrl = 'https://lets-orange.b-cdn.net/lektor-orange-2026/ORANGE_18.mp3';
const audio1Url = 'https://lets-orange.b-cdn.net/lektor-orange-2026/ORANGE_14.mp3';
const animation2Url = 'https://lets-orange.b-cdn.net/animacje/LOQ_S1_D_02.json';
const videoUrl = `${CONFIG.CDN_VIDEO_URL}/robot-inhouse-01.mp4`;

const QuestionSegment3: FC<QuestionSegmentProps> = ({ formComponent }) => {
  const { t } = useTranslationWithPrefix('views.process.quizQuestions');
  const [nextSegmentVisible, setNextSegmentVisible] = useState(false);
  const handleNext = () => setNextSegmentVisible(true);

  return nextSegmentVisible ? (
    <QuestionWrapper
      animationUrl={animation2Url}
      audioUrl={audioUrl}
      formComponent={formComponent}
      segmentContent={
        <>
          <p className="lead fw-bold">{t('questions.3.titles.3')}</p>
          <div className="flex flex-column max-w-(--breakpoint-md) gap-s">
            <p className="lead">{t('questions.3.content.3')}</p>
          </div>
        </>
      }
    />
  ) : (
    <QuestionWrapper
      audioUrl={audio1Url}
      onNext={handleNext}
      segmentContent={
        <>
          <p className="lead fw-bold">{t('questions.3.titles.1')}</p>
          <div className="flex flex-column max-w-(--breakpoint-md) gap-s">
            <p className="lead">{t('questions.3.content.1')}</p>
            <p className="lead">
              {parseHtml(DOMPurify.sanitize(t('questions.3.content.2'), DomPurifyConfig))}
            </p>
          </div>
          <p className="lead fw-bold">{t('questions.3.titles.2')}</p>
        </>
      }
      videoUrl={videoUrl}
    />
  );
};

export default QuestionSegment3;
